// extracted by mini-css-extract-plugin
module.exports = {"tips":"FJStockTipsView_tips__3Za70","active":"FJStockTipsView_active__QJH45","text":"FJStockTipsView_text__39q_R"};